const defaultProduct = {
  spuId: null, // Integer SPU ID
  categoryId: null, // Integer 产品类别ID
  spuName: null, // 商品名称
  spuModel: null, // 产品型号
  subName: null, // 副标题（一般是促销信息）
  spuDesp: null, // 产品描述信息
  saleable: 0, // Integer 是否上架(0-下架，1-上架)
  isRecommend: 0, // Integer 是否推荐
  isNew: 0, // Integer 是否新品
  isStock: 0,// Integer 是否库存
  isVerify: 0, // Integer 审核状态 0：未审核-》 1：审核通过-》 2：审核未通过
  specAttachment: null, // 规格书附件(URL地址)
  dcycle: null, // Integer 交付周期
  afterService: `产品保修更换说明
1）所有恒达微波产品保修期限为一年(以恒达微波发货日期为准)；
2）保修期过后，恒达微波仍然维修，但需要收取适当费用；
3）有限保修期间，恒达微波将为损坏零件提供免费更换服务；
4）更换后的零件作为特殊部分延续保修期10个月。

有限保修义务
属于下列情况的产品(包括部件) 故障或损坏，不在有限保修之列:
1）产品已经超出了保修期；
2）任何不属于恒达微波的产品；
3）任何由于事故、滥用、使用不当、保养不当而损坏的产品；
4）任何未经恒达微波授权而被改动、拆卸的产品；
5）任何产品编号已被删除无法追溯产品购买信息的产品。

  `, // 售后服务
  productsIntroText: null, // 产品介绍富文本字符串
  failReason: null, // 审核未通过原因
  stockNum: null, // Integer 产品数量
  skus: [], // SKU 列表
  spuParams: [], // SPU 参数列表
  specImages: [], // SPU 图片列表,
  skuStockList: [],
  tmpSpecImages: [],
  rawSkus: [],
  rawSpuImageParamId: null
};

const product = {
  state: () => ({
    // const defaultProductParam = {
    //   albumPics: '',
    //   brandId: null,
    //   brandName: '',
    //   deleteStatus: 0,
    //   description: '',
    //   detailDesc: '',
    //   detailHtml: '',
    //   detailMobileHtml: '',
    //   detailTitle: '',
    //   feightTemplateId: 0,
    //   flashPromotionCount: 0,
    //   flashPromotionId: 0,
    //   flashPromotionPrice: 0,
    //   flashPromotionSort: 0,
    //   giftPoint: 0,
    //   giftGrowth: 0,
    //   keywords: '',
    //   lowStock: 0,
    //   name: '',
    //   newStatus: 0,
    //   note: '',
    //   originalPrice: 0,
    //   pic: '',
    //   //会员价格{memberLevelId: 0,memberPrice: 0,memberLevelName: null}
    //   memberPriceList: [],
    //   //商品满减
    //   productFullReductionList: [{ fullPrice: 0, reducePrice: 0 }],
    //   //商品阶梯价格
    //   productLadderList: [{ count: 0, discount: 0, price: 0 }],
    //   previewStatus: 0,
    //   price: 0,
    //   productAttributeCategoryId: null,
    //   //商品属性相关{productAttributeId: 0, value: ''}
    //   productAttributeValueList: [],
    //   //商品sku库存信息{lowStock: 0, pic: '', price: 0, sale: 0, skuCode: '', spData: '', stock: 0}
    //   skuStockList: [],
    //   //商品相关专题{subjectId: 0}
    //   subjectProductRelationList: [],
    //   //商品相关优选{prefrenceAreaId: 0}
    //   prefrenceAreaProductRelationList: [],
    //   productCategoryId: null,
    //   productCategoryName: '',
    //   productSn: '',
    //   promotionEndTime: '',
    //   promotionPerLimit: 0,
    //   promotionPrice: null,
    //   promotionStartTime: '',
    //   promotionType: 0,
    //   publishStatus: 0,
    //   recommandStatus: 0,
    //   sale: 0,
    //   serviceIds: '',
    //   sort: 0,
    //   stock: 0,
    //   subTitle: '',
    //   unit: '',
    //   usePointLimit: 0,
    //   verifyStatus: 0,
    //   weight: 0
    // };
    product: {
      spuId: null, // Integer SPU ID
      categoryId: null, // Integer 产品类别ID
      spuName: null, // 商品名称
      spuModel: null, // 产品型号
      subName: null, // 副标题（一般是促销信息）
      spuDesp: null, // 产品描述信息
      saleable: 0, // Integer 是否上架(0-下架，1-上架)
      isRecommend: 0, // Integer 是否推荐
      isNew: 0, // Integer 是否新品
      isStock: 0,// Integer 是否库存
      isVerify: 0, // Integer 审核状态 0：未审核-》 1：审核通过-》 2：审核未通过
      specAttachment: null, // 规格书附件(URL地址)
      dcycle: null, // Integer 交付周期
      afterService: "", // 售后服务
      productsIntroText: null, // 产品介绍富文本字符串
      failReason: null, // 审核未通过原因
      stockNum: null, // Integer 库存量
      skus: [], // SKU 列表
      spuParams: [], // SPU 参数列表
      specImages: [], // SPU 图片列表,
      skuStockList: [],
      tmpSpecImages: [],
      rawSkus: [],// 原始SKU列表
      rawSpuImageParamId: null// 原始SPU商品主图属性ID
    }
  }),
  mutations: {
    SET_PRODUCT: (state, product) => {
      state.product = product;
    },
    RESET_PRODUCT: state => {
      state.product = Object.assign({}, defaultProduct);
    },
    SET_PRODUCT_: (state, { attr, index }) => {
      console.log("UPDATE_ATTR", attr, index);
    },
    HANDLE_RESPONSE_PRODUCT: (state, response) => {
      console.log("HELLO >> HANDLE_RESPONSE_PRODUCT >> response", response);

      let product = Object.assign({}, defaultProduct);
      if (response && response.data) {
        const data = response.data;

        let rawSpuImageParamId = 163;
        if (data.specImages && data.specImages.length > 0) {
          rawSpuImageParamId = data.specImages[0].paramId;
        }

        product.spuId = data.spuId;
        product.categoryId = data.categoryId;
        product.spuName = data.spuName;
        product.spuModel = data.spuModel;
        product.subName = data.subName;
        product.spuDesp = data.spuDesp;
        product.saleable = data.saleable;
        product.isRecommend = data.isRecommend;
        product.isNew = data.isNew;
        product.isStock = data.isStock;
        product.isVerify = data.isVerify;
        product.specAttachment = data.specAttachment;
        product.dcycle = data.dcycle;
        product.afterService = data.afterService || defaultProduct.afterService;
        product.productsIntroText = data.productsIntroText;
        product.failReason = data.failReason;
        product.stockNum = data.stockNum;
        product.skus = data.skus;
        product.spuParams = data.spuParams;
        product.specImages = data.specImages;
        product.skuStockList = [];
        product.tmpSpecImages = [];
        product.rawSkus = data.skus;
        product.rawSpuImageParamId = rawSpuImageParamId;
      }

      console.log("HELLO >> HANDLE_RESPONSE_PRODUCT >> product", product);
      state.product = product;
    }
  }
};

export default product;



// WEBPACK FOOTER //
// ./src/store/modules/product.js